import { clsx } from 'clsx';

import type IBackdrop from './interfaces/IBackdrop';

import styles from './scss/Backdrop.module.scss';

function Backdrop({ children, isFullscreen = false }: IBackdrop) {
  return (
    <div className={clsx(styles.root, { [styles.fullscreen]: isFullscreen })}>
      {children}
    </div>
  );
}

export default Backdrop;
